import { SIQLauncherUnreadBadgeTheme } from "./SIQLauncherUnreadBadgeTheme";
export class SIQLauncherTheme {
  backgroundColor = "null";
  iconColor = "null";
  UnreadBadge = new SIQLauncherUnreadBadgeTheme();
}
//# sourceMappingURL=SIQLauncherTheme.js.map